export default __webpack_public_path__ + "static/media/arizonaCardinals@2x.83388135.jpg";